import React, { useEffect, useState } from 'react';

import { GridView } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import TableViewIcon from '@mui/icons-material/TableView';
import { Breadcrumbs, Grid, IconButton, Snackbar, Stack, Tab, Tabs, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Link, useLocation } from 'react-router-dom';

import { Footer, Header } from './common_components';
import { COOKIE_CONSENT, isMobile } from './common_components/constants';
import { StyledBreadcrumb } from './common_components/styled';
import { useFetchAllData } from './hooks/useClientDataService';
import { ErrorBoundary } from './pages';
import { Routers, tabRoutes } from './Routes';

dayjs.extend(utc);

export const App = () => {
  let location = useLocation();
  useFetchAllData();

  const [value, setValue] = useState(location.pathname);
  const [cookieConsent, setCookieConsent] = useState(
    localStorage.getItem('COOKIE_CONSENT') !== 'false'
  );

  const [isTableViewSelected, setIsTableViewSelected] = useState(
    isMobile &&
      localStorage.getItem('display-type') &&
      localStorage.getItem('display-type') === 'table'
      ? true
      : localStorage.getItem('display-type') === 'table'
  );

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    localStorage.setItem('COOKIE_CONSENT', false);
    setCookieConsent(false);
  };
  useEffect(() => {
    if (location?.pathname?.includes('/homeScreen') || location.pathname === '/') {
      setValue('/ongoing-ido');
    } else {
      setValue(location.pathname);
    }
  }, [location]);

  const onViewSelect = (type) => {
    localStorage?.setItem('display-type', type);
    setIsTableViewSelected(type === 'table');
  };
  const getRoute = () => {
    let title = "IDO/IEO/ICO'S";
    if (location.pathname.includes('ido')) {
      title = "IDO/IEO/ICO'S";
    } else if (location.pathname.includes('nft')) {
      title = "NFT's";
    }
    return (
      <Breadcrumbs aria-label="breadcrumb" sx={{ ml: 2, pl: 2, mb: 2 }}>
        <StyledBreadcrumb label="Home" icon={<HomeIcon fontSize="small" />} />
        <StyledBreadcrumb label={title} />
      </Breadcrumbs>
    );
  };

  const action = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <>
      <Header />
      <ErrorBoundary>
        <div style={{ minHeight: '80vh' }}>
          {!(
            location?.pathname.includes('Details') || location?.pathname.includes('disclaimer')
          ) && (
            <>
              {getRoute()}
              <Grid container>
                <Grid item md={6} xs={12}>
                  <Tabs
                    value={value}
                    textColor="secondary"
                    sx={{ ml: 3 }}
                    indicatorColor="secondary">
                    {tabRoutes[value.includes('ido') ? 'ido' : 'nft'].map((item, index) => (
                      <Tab
                        label={item.label}
                        component={Link}
                        to={item.to}
                        value={item.value}
                        key={index}
                      />
                    ))}
                  </Tabs>
                </Grid>
                <Grid item md={6} xs={12} sx={{ justifyContent: 'flex-end', display: 'flex' }}>
                  {!location.pathname.includes('nft') && (
                    <Stack direction="row">
                      <Tooltip title="GridView">
                        <IconButton
                          size="large"
                          edge="start"
                          color="inherit"
                          onClick={() => onViewSelect('cards')}>
                          <GridView sx={{ color: isTableViewSelected ? '#c1bfbf' : '#394c5a' }} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="TableView">
                        <IconButton
                          size="large"
                          edge="start"
                          color="inherit"
                          target="_blank"
                          onClick={() => onViewSelect('table')}>
                          <TableViewIcon
                            sx={{ color: !isTableViewSelected ? '#c1bfbf' : '#394c5a' }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  )}
                </Grid>
              </Grid>
            </>
          )}
          <Routers />
        </div>
      </ErrorBoundary>
      <Snackbar
        open={cookieConsent}
        sx={{ borderRadius: '12px' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={handleClose}
        message={COOKIE_CONSENT}
        action={action}
      />
      <Footer />
    </>
  );
};
